// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeedbackMobApp-module__container--ynpv4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    padding: 10px;
    text-align: center;
}

.FeedbackMobApp-module__mainBox--bJxsN {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.FeedbackMobApp-module__secondLine--mrINx {
    display: flex;
    gap: 10px;
}

.FeedbackMobApp-module__secondLine--mrINx>div {
    width: 33%;
}

.FeedbackMobApp-module__container--ynpv4>form {
    width: 800px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.FeedbackMobApp-module__btnBox--R_y60 {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}


.FeedbackMobApp-module__successMessage--OPAYj,
.FeedbackMobApp-module__errorMessage--Jfx97 {
    display: flex;
    flex-direction: column;
    color: green;
    font-size: 30px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
}

.FeedbackMobApp-module__successMessage--OPAYj>p,
.FeedbackMobApp-module__errorMessage--Jfx97>p {
    color: green;
    font-size: 30px;
    font-weight: bold;
}

.FeedbackMobApp-module__successMessage--OPAYj>span>svg,
.FeedbackMobApp-module__errorMessage--Jfx97>span>svg {
    color: green;
    font-size: 90px;
}

.FeedbackMobApp-module__errorMessage--Jfx97 {
    color: red;
}

.FeedbackMobApp-module__errorMessage--Jfx97>p {
    color: red;
}

.FeedbackMobApp-module__errorMessage--Jfx97>span>svg {
    color: red;
}

.FeedbackMobApp-module__colorBox--FjJ0a {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.FeedbackMobApp-module__colorBox--FjJ0a>p {
    margin: 0;
}

.FeedbackMobApp-module__colorBox--FjJ0a>p {
    margin: 0;
}

.FeedbackMobApp-module__icon--ol_Bu>svg {
    color: var(--color-primary);
    font-size: 25px;
}

@media (max-width: 830px) {
    .FeedbackMobApp-module__container--ynpv4>form {
        width: 100%;
    }
}


@media (max-width: 520px) {
    .FeedbackMobApp-module__secondLine--mrINx {
        flex-direction: column;
    }

    .FeedbackMobApp-module__secondLine--mrINx>div {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/feedback-mob-app/FeedbackMobApp.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 70vh;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.mainBox {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.secondLine {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.secondLine>div {\r\n    width: 33%;\r\n}\r\n\r\n.container>form {\r\n    width: 800px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n\r\n.successMessage,\r\n.errorMessage {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: green;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 50px;\r\n}\r\n\r\n.successMessage>p,\r\n.errorMessage>p {\r\n    color: green;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n}\r\n\r\n.successMessage>span>svg,\r\n.errorMessage>span>svg {\r\n    color: green;\r\n    font-size: 90px;\r\n}\r\n\r\n.errorMessage {\r\n    color: red;\r\n}\r\n\r\n.errorMessage>p {\r\n    color: red;\r\n}\r\n\r\n.errorMessage>span>svg {\r\n    color: red;\r\n}\r\n\r\n.colorBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n@media (max-width: 830px) {\r\n    .container>form {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 520px) {\r\n    .secondLine {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .secondLine>div {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FeedbackMobApp-module__container--ynpv4`,
	"mainBox": `FeedbackMobApp-module__mainBox--bJxsN`,
	"secondLine": `FeedbackMobApp-module__secondLine--mrINx`,
	"btnBox": `FeedbackMobApp-module__btnBox--R_y60`,
	"successMessage": `FeedbackMobApp-module__successMessage--OPAYj`,
	"errorMessage": `FeedbackMobApp-module__errorMessage--Jfx97`,
	"colorBox": `FeedbackMobApp-module__colorBox--FjJ0a`,
	"icon": `FeedbackMobApp-module__icon--ol_Bu`
};
export default ___CSS_LOADER_EXPORT___;
